import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaIconComponent } from 'ra-ui';
import { DocumentConfigScopeEnum } from '@domain';
import { RaModalComponent } from 'src/app/shared/components/ra-modal/ra-modal.component';

/**
 * Pergunta ao usuário onde a configuração que ele acabou de editar deve valer.
 *
 * As alterações já estão gravadas no documento (o auto-save persiste enquanto ele mexe).
 * Este modal decide apenas se elas também viram o padrão dos próximos documentos e se
 * reaplicam nos que já existem no serviço.
 *
 * A terceira opção só aparece quando o documento pertence a um serviço.
 */
@Component({
    selector: 'modal-config-scope',
    templateUrl: 'modal-config-scope.component.html',
    styleUrl: 'modal-config-scope.component.scss',
    imports: [CommonModule, RaModalComponent, RaIconComponent, TranslatePipe],
})
export class ModalConfigScopeComponent {
    /** Documento pertence a um serviço — habilita a opção "todos os documentos do serviço". */
    public hasOrder = input<boolean>(false);
    /** Loading enquanto o alcance escolhido é propagado. */
    public loading = input<boolean>(false);

    public close = output<void>();
    public scopeSelected = output<DocumentConfigScopeEnum>();

    public Scope = DocumentConfigScopeEnum;

    /** Opções renderizadas, na ordem do menos para o mais abrangente. */
    public options = computed(() => {
        const base = [
            {
                scope: DocumentConfigScopeEnum.DOCUMENT,
                titleKey: 'document.edit.documentConfig.saveScopeThisDocTitle',
                descriptionKey: 'document.edit.documentConfig.saveScopeThisDocDescription',
            },
            {
                scope: DocumentConfigScopeEnum.DEFAULTS,
                titleKey: 'document.edit.documentConfig.saveScopeDefaultsTitle',
                descriptionKey: 'document.edit.documentConfig.saveScopeDefaultsDescription',
            },
        ];

        if (!this.hasOrder()) return base;

        return [
            ...base,
            {
                scope: DocumentConfigScopeEnum.ALL_DOCS,
                titleKey: 'document.edit.documentConfig.saveScopeAllDocsTitle',
                descriptionKey: 'document.edit.documentConfig.saveScopeAllDocsDescription',
            },
        ];
    });
}
